// src/utils/leadTrackerStore.js
// Firestore I/O for the Lead Tracker. Two tiny stores:
//   lead_tracker_settings/{ownerUid} — { goalsByYear: { "2026": {...} } }
//   lead_tracker_overrides/{leadId}  — { callOrAppt: "call"|"appt"|null, ... }
// Everything else the tracker shows is derived live (see leadTracker.js).
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import { firestored } from "../firebase/firebaseConfig";

const SETTINGS_COLLECTION = "lead_tracker_settings";
const OVERRIDES_COLLECTION = "lead_tracker_overrides";

export async function loadTrackerSettings(ownerId) {
  if (!ownerId) return { goalsByYear: {} };
  try {
    const snap = await getDoc(doc(firestored, SETTINGS_COLLECTION, ownerId));
    if (!snap.exists()) return { goalsByYear: {} };
    return { goalsByYear: {}, ...(snap.data() || {}) };
  } catch (err) {
    console.error("loadTrackerSettings failed:", err);
    return { goalsByYear: {} };
  }
}

export async function saveTrackerGoals(ownerId, year, goals) {
  if (!ownerId) return;
  await setDoc(
    doc(firestored, SETTINGS_COLLECTION, ownerId),
    {
      goalsByYear: { [String(year)]: goals },
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
}

export async function loadTrackerOverrides() {
  try {
    const snap = await getDocs(collection(firestored, OVERRIDES_COLLECTION));
    const map = {};
    snap.docs.forEach((d) => {
      map[d.id] = d.data();
    });
    return map;
  } catch (err) {
    console.error("loadTrackerOverrides failed:", err);
    return {};
  }
}

// Pass callOrAppt: "call" | "appt" to override, null to clear (derived value
// comes back). Non-destructive by design — the lead itself is never touched.
export async function saveTrackerOverride(leadId, patch, userId) {
  if (!leadId) return;
  await setDoc(
    doc(firestored, OVERRIDES_COLLECTION, leadId),
    { ...patch, updatedBy: userId || "", updatedAt: Date.now() },
    { merge: true },
  );
}
